<template>
  <div
    class="compensation-terms-wrapper"
    :class="{
      'compensation-terms-wrapper--no-margin-top': noMarginTop,
      'compensation-terms-wrapper--row': layout === 'row'
    }">
    <h5
      v-if="title"
      class="compensation-terms-title">{{ title }}</h5>
    <p
      v-if="description"
      class="compensation-terms-desc">{{ description }}</p>
    <div
      class="compensation-terms-methods"
      :class="{
        'compensation-terms-methods--compact': compact,
        'compensation-terms-methods--row': layout === 'row'
      }">
      <div class="compensation-method">
        <span class="compensation-icon-cell">
          <Icon
            name="credit-card"
            :size="compensationIconSize"
            color="#1cc259"
            icon-class="compensation-icon" />
        </span>
        <div class="compensation-method-text">
          <span class="compensation-label">Cartão</span>
          <span class="compensation-duration">Instantâneo</span>
        </div>
      </div>
      <div class="compensation-method">
        <span class="compensation-icon-cell">
          <Icon
            name="pix"
            :size="compensationIconSize"
            color="#1cc259"
            icon-class="compensation-icon" />
        </span>
        <div class="compensation-method-text">
          <span class="compensation-label">PIX</span>
          <span class="compensation-duration">Até 24h</span>
        </div>
      </div>
      <div class="compensation-method">
        <span class="compensation-icon-cell">
          <Icon
            name="document-text"
            :size="compensationIconSize"
            color="#1cc259"
            icon-class="compensation-icon" />
        </span>
        <div class="compensation-method-text">
          <span class="compensation-label">Boleto</span>
          <span class="compensation-duration">Até 3 dias</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Common/Icon.vue'

export default {
  name: 'CompensationTermsMethods',
  components: {
    Icon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    noMarginTop: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: ''
    }
  },
  computed: {
    compensationIconSize () {
      return (this.layout === 'row' || this.compact) ? 18 : 22
    }
  }
}
</script>

<style lang="scss" scoped>
$compensation-green: #1cc259;

.compensation-terms-wrapper {
  margin-top: 0.5rem;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
}

.compensation-terms-wrapper--no-margin-top {
  margin-top: 0;
}

.compensation-terms-wrapper--row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  padding: 0.5rem 1.25rem;

  .compensation-terms-title {
    width: 100%;
    margin-bottom: 0;
  }

  .compensation-terms-desc {
    flex: 1 1 auto;
    margin-bottom: 0;
    min-width: 200px;
  }

  .compensation-terms-methods {
    flex-shrink: 0;
  }
}

.compensation-terms-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.35rem;
}

.compensation-terms-desc {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0 0 0.5rem;
  line-height: 1.4;
}

.compensation-terms-methods {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.75rem;
}

.compensation-method {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  flex: 1 1 0;
}

.compensation-method-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.compensation-terms-methods--row {
  .compensation-method {
    flex-direction: row;
    align-items: center;
    min-width: 0;
    flex: 0 0 auto;
    gap: 0.35rem;
  }

  .compensation-method-text {
    align-items: flex-start;
  }

  ::v-deep .compensation-icon {
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .compensation-icon-cell {
    width: 22px;
    height: 22px;
  }

  .compensation-label {
    font-size: 0.8rem;
  }

  .compensation-duration {
    margin: 0;
    font-size: 0.7rem;
  }
}

.compensation-icon-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9999px;
  background: rgba(28, 194, 89, 0.18);
  flex-shrink: 0;
  margin-bottom: 0.45rem;
}

.compensation-terms-methods--row .compensation-icon-cell {
  margin-bottom: 0;
}

/* Verde #1cc259 = $financial-green (botão Gerar pagamento) – forçar no span e no SVG */
.compensation-icon-cell ::v-deep .icon,
.compensation-icon-cell ::v-deep .compensation-icon {
  background: none !important;
}

.compensation-icon-cell ::v-deep svg {
  color: #1cc259 !important;
  stroke: #1cc259 !important;
}

::v-deep .compensation-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.compensation-label {
  font-weight: 500;
  color: #111827;
  font-size: 0.85rem;
}

.compensation-duration {
  font-size: 0.75rem;
  color: #64748b;
}

@media (max-width: 420px) {
  .compensation-terms-methods {
    justify-content: center;
  }

  .compensation-method {
    min-width: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/CompensationTermsMethods.vue